import { render, staticRenderFns } from "./newTemplateModal.vue?vue&type=template&id=ab270fd8&scoped=true"
import script from "./newTemplateModal.vue?vue&type=script&lang=js"
export * from "./newTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./newTemplateModal.vue?vue&type=style&index=0&id=ab270fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab270fd8",
  null
  
)

export default component.exports